import { render, staticRenderFns } from "./TagOptionsInput.vue?vue&type=template&id=b6d74042&scoped=true&"
import script from "./TagOptionsInput.vue?vue&type=script&lang=js&"
export * from "./TagOptionsInput.vue?vue&type=script&lang=js&"
import style0 from "./TagOptionsInput.vue?vue&type=style&index=0&id=b6d74042&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d74042",
  null
  
)

export default component.exports